import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ORG } from '../landing/landing.content';

@Component({
  selector: 'app-workspace-sidebar-brand',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './workspace-sidebar-brand.component.html',
  styleUrl: './workspace-sidebar-brand.component.css',
})
export class WorkspaceSidebarBrandComponent {
  readonly ORG = ORG;
  readonly logoUrl = '/assets/tenants/pda/logo.png';

  /** Module label shown below org name, e.g. "DMS · Document Digitization". */
  @Input() moduleTag = '';

  @Output() readonly brandNavigate = new EventEmitter<void>();

  onBrandClick(): void {
    this.brandNavigate.emit();
  }
}
